import { render, staticRenderFns } from "./DeleteVoucherType.vue?vue&type=template&id=6a2cbd27"
import script from "./DeleteVoucherType.vue?vue&type=script&lang=js"
export * from "./DeleteVoucherType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports